import { Squares2X2Icon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import { useRedirect } from "src/hooks/useRedirect";
import { useActiveProjectQuery } from "src/hooks/useActiveProjectQuery";
import { useFeatureFlag } from "src/contexts/posthog.context";
import { FLAGS } from "src/posthog/flags";
import type { BooleanState } from "src/types/BooleanState";
import { useTranslation } from "src/translations";

// Shortcut from the canvas into the Studio flow. Only shown when the
// design-studio flag is on — mirrors CanvasButton, sits directly beneath it.
export function StudioButton(props: { expand: BooleanState }) {
  const enabled = useFeatureFlag(FLAGS.designStudio);
  const redirect = useRedirect();
  const projectQuery = useActiveProjectQuery();
  const project = projectQuery.data;
  const { t } = useTranslation();
  if (!enabled) return null;
  const label = props.expand.isOn ? (
    <span className="flex-1 truncate text-start text-subtitle-2">{t("nav.studio")}</span>
  ) : null;
  return (
    <button
      className={classNames(
        "flex flex-row space-x-2 rounded cursor-pointer flex-1 justify-center items-center h-[28px] min-h-[28px] transition-all text-neutral-7 hover:text-primary-7 hover:bg-primary-1",
        props.expand.isOn && "px-[8px]"
      )}
      onClick={async () => {
        if (!project) return;
        await redirect.studio({ projectId: project.id });
      }}
    >
      <Squares2X2Icon className="w-4 h-4 shrink-0" />
      {label}
    </button>
  );
}
